module.exports = __webpack_public_path__ + "static/media/Fotolia_Team_800x500.6075be0b.jpg";